window.onload = function() {
    //marquee

    function Marquee(selector, speed) {
        const parentSelector = document.querySelector(selector);
        const clone = parentSelector.innerHTML;
        parentSelector.insertAdjacentHTML('beforeend', clone);
        parentSelector.insertAdjacentHTML('beforeend', clone);

        let i = 0;
        const firstElement = parentSelector.children[0];

        function step() {
            i += speed;
            if (i > firstElement.clientWidth) {
                i = 0;
            }
            parentSelector.style.transform = `translateX(-${i}px)`;
            requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    // 1. Class selector for marquee
    // 2. Marquee speed 0.2
    Marquee('.marquee', 0.2);
};